import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Content = styled(Box)`
  border-top-left-radius: ${({ theme }) => theme.border_radius.box};
  overflow-y: auto;
  width: calc(100vw - 260px);
  background-color: ${({ theme }) => getThemeColor('grey_6', theme)};

  @media (max-width: 1200px) {
    width: 100vw;
  }
`
